export const AUTH_PATHS = {
  login: '/platform/auth/login',
  logout: '/platform/auth/logout',
  refresh: '/platform/auth/refresh',
  session: '/platform/auth/me',
} as const

export function isRefreshEndpoint(url: string): boolean {
  return url.includes(AUTH_PATHS.refresh)
}

export function isLoginEndpoint(url: string): boolean {
  return url.includes(AUTH_PATHS.login)
}
